import {HttpClient} from '@angular/common/http';
// required for AOT compilation
import {TranslateHttpLoader} from '@ngx-translate/http-loader';

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
	// to prevent cache issues with translations we	append a timestamp to the url
	return new TranslateHttpLoader(http, './assets/i18n/', '.json?v=' + Date.now());
}
